import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

interface Folder {
  name: string;
  guid: string;
  deletable: boolean;
  can_add_subfolder: boolean;
  children?: Folder[];
}


@Component({
  selector: 'app-default-folder-structure',
  templateUrl: './default-folder-structure.page.html',
  styleUrls: ['./default-folder-structure.page.scss'],
})
export class DefaultFolderStructurePage implements OnInit {

  @Input() for_clients = 1;
  @ViewChild('folderInput') folderInputRef!: ElementRef;
    rootFolder: Folder = {
  name: 'Root',
  guid: 'root',
  deletable: false,
  can_add_subfolder: true,
  children: [
    {
      name: 'Projects',
      guid: 'projects',
      deletable: false,
      can_add_subfolder: false,
      children: []
    }
  ]
};

  showModal = false;
  modalInput = '';
  targetParent: Folder | null = null;



  constructor(public globalService: GlobalService,private apiService: ApiService,private modalController: ModalController) { }

  // Same as the API: contacts_manage_default_folders (for_clients = 1) / companies_manage_default_folders (0)
  CanUpdate(): boolean {
    return this.globalService.Can(this.for_clients == 1 ? 'contacts_manage_default_folders' : 'companies_manage_default_folders');
  }

  ngOnInit() {
    this.GetData();
  }

  async GetData() {
    let data: any = await this.apiService.get(`default_folders/${this.for_clients}`);
    console.log(data);
    if(data.success) {
      console.log("Success");
      console.log(data.data[0].folder_json);
      if(data.data[0].folder_json) {
        console.log("add too");
        this.rootFolder.children = JSON.parse(data.data[0].folder_json)
        console.log("added");
      } 
    }

  }

  async Update() {
    let post_data = {
      json: JSON.stringify(this.rootFolder.children)
    }
    let data: any = await this.apiService.put(`default_folders/${this.for_clients}`,post_data);
    this.globalService.presentToastMessage(data.message,data.success);
  }

  async Close(){
    this.modalController.dismiss();
  }



  openModal(parent: Folder) {
    this.targetParent = parent;
    this.modalInput = '';
    this.showModal = true;
    setTimeout(() => {
      this.folderInputRef?.nativeElement?.focus();
    });

  }

  closeModal() {
    this.showModal = false;
    this.modalInput = '';
    this.targetParent = null;
  }





  confirmAddFolder() {
    const folderName = this.modalInput.trim();

    if (!folderName) {
      alert('Folder name cannot be empty.');
      return;
    }

    const invalidChars = /[\\/:*?"<>|]/;
    if (invalidChars.test(folderName)) {
      alert('Folder name contains invalid characters: \\ / : * ? " < > |');
      return;
    }

    const parent = this.targetParent;
    const nameExists = parent?.children?.some(child => child.name.toLowerCase() === folderName.toLowerCase());
    if (nameExists) {
      alert(`A folder named "${folderName}" already exists at this level.`);
      return;
    }

    if (parent) {
      if (!parent.children) parent.children = [];
      parent.children.push({ name: folderName,guid: this.globalService.createGUID(),deletable: true,can_add_subfolder: true, children: [] });
    }

    this.closeModal();
  }

removeFolderByGUID(guid: string) {
    this.rootFolder = this.removeFolderRecursive(this.rootFolder, guid)!;
  }

  private removeFolderRecursive(folder: Folder, guid: string): Folder | null {
    if (!folder.children) return folder;

    folder.children = folder.children
      .map(child => this.removeFolderRecursive(child, guid))
      .filter(child => child !== null) as Folder[];

    return folder.guid === guid ? null : folder;
  }


}
